import { getSafeWindow } from '@wix/gg-common-lib/utils';

export class PersistentStore<T> {
  private key: string;
  private initialState: T;

  constructor(key: string, initialState: T) {
    this.key = key;
    this.initialState = initialState;
  }

  getState() {
    const state = getSafeWindow()?.sessionStorage.getItem(this.key);
    return state ? JSON.parse(state) : this.initialState;
  }

  setState(state: T) {
    getSafeWindow()?.sessionStorage.setItem(this.key, JSON.stringify(state));
  }
}
